import React from 'react';
export function CostComparison() {
  const data = [{
    sin: 'Berrinches diarios por el celular',
    costo: 'Estrés, gritos y culpa acumulada'
  }, {
    sin: 'Tardes perdidas sin saber qué hacer',
    costo: 'Horas de tu vida que no vuelven'
  }, {
    sin: 'Actividades que duran 5 minutos',
    costo: 'Frustración y rendición'
  }, {
    sin: 'Noches buscando ideas en Google',
    costo: 'El mismo ciclo, mañana de vuelta'
  }, {
    sin: 'Sentirte mal padre/madre',
    costo: 'El daño más costoso de todos'
  }, {
    sin: 'Dependencia que crece cada semana',
    costo: 'Más difícil de revertir cada día'
  }];
  return <section className="bg-dark-900 py-20 px-4" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-cream mb-12" data-id="element-63">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-dark-800 rounded-3xl overflow-hidden border border-urgency/30 shadow-2xl mb-12" data-id="element-64">
          <div className="grid grid-cols-2 bg-dark-900 border-b border-urgency/30" data-id="element-65">
            <div className="p-6 text-center font-bold text-cream/80 text-lg" data-id="element-66">
              Sin MegaPack
            </div>
            <div className="p-6 text-center font-bold text-urgency text-lg" data-id="element-67">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-urgency/10" data-id="element-68">
            {data.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-dark-900/30 transition-colors" data-id="element-69">
                <div className="p-6 text-cream/90 flex items-center justify-center text-center" data-id="element-70">
                  {row.sin}
                </div>
                <div className="p-6 text-urgency/90 font-medium flex items-center justify-center text-center bg-urgency/5" data-id="element-71">
                  {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-72">
          <p className="text-2xl md:text-4xl font-bold text-cream italic" data-id="element-73">
            El próximo domingo puede ser diferente.
          </p>
          <p className="text-xl md:text-2xl text-primary mt-4" data-id="element-74">
            "La próxima tarde puede ser diferente." 🌿
          </p>
        </div>
      </div>
    </section>;
}